/*** * Imports * ***/

import axios from "axios";

/*** * Values * ***/

let ConfiguratorData = {};

/*** * Utils * ***/

async function whoami(options = {}) {
  /*** * Variables * ***/

  let url;

  /*** * * ***/

  // Trick to get current base url
  await fetch("/favicon.ico")
    .then((res) => {
      url = new URL(res.url);
    })
    .catch((err) => {
      url = new URL(err.url);
    });

  /*** * * ***/

  if (options?.port) {
    url.port = options.port;
  }

  /*** * * ***/

  return url.origin;
}

function isDisabled(v) {
  if (!v) return false;

  switch (v) {
    case null:
    case undefined:
    case "":
    case "-1":
    case "0":
    case "false":
    case "False":
      return true;
      // eslint-disable-next-line no-unreachable
      break;
    default:
      return false;
      // eslint-disable-next-line no-unreachable
      break;
  }
}

async function getApiUrl(rawApiUrl) {
  let url = "";

  url = isDisabled(rawApiUrl) ? await whoami() : rawApiUrl;
  if (!url.endsWith("/api")) url = url + "/api";

  return url;
}

/*** * Exports * ***/

export default async function Configurator() {
  let sources = [];

  let raw = {};
  let refined = {};

  /*** * * ***/

  sources = ["/configurator_static.json", "/configurator_entrypoint.json"];

  /*** * Return ConfiguratorData.Result if it's already calculated * ***/

  if (ConfiguratorData.Result) {
    return ConfiguratorData.Result;
  }

  /*** * Read Sources * ***/

  // sources
  for (let source of sources) {
    await axios
      .get(source)
      .then((res) => {
        if (typeof res.data === "object" && res.data !== null) {
          for (let i = 0; i < Object.keys(res.data).length; i++) {
            raw[Object.keys(res.data)[i]] = Object.values(res.data)[i];
          }
        }
      })
      .catch((err) => {
        console.error('Configurator : Error fetching "' + source + '" data : ', err);
      });
  }

  // env
  if (process.env.REACT_APP_UI_API_URL) raw.UI_API_URL = process.env.REACT_APP_UI_API_URL;
  if (process.env.REACT_APP_UI_API_WSS_ENABLE)
    raw.UI_API_WSS_ENABLE = process.env.REACT_APP_UI_API_WSS_ENABLE;
  if (process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_ENABLE)
    raw.TRANSMITTER_REDUNDANCY_SWITCH_ENABLE =
      process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_ENABLE;
  if (process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_ADDRESS)
    raw.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESS =
      process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_ADDRESS;
  if (process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_TAGS)
    raw.TRANSMITTER_REDUNDANCY_SWITCH_TAGS = JSON.parse(
      process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_TAGS,
    );
  if (process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES)
    raw.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES = JSON.parse(
      process.env.REACT_APP_TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES,
    );

  /*** * * ***/

  refined.API_URL = await getApiUrl(raw?.UI_API_URL);

  refined.API_WS_PREFIX = isDisabled(raw?.UI_API_WSS_ENABLE) ? "ws" : "wss";

  refined.TRANSMITTER_REDUNDANCY_SWITCH_ENABLE = isDisabled(
    raw?.TRANSMITTER_REDUNDANCY_SWITCH_ENABLE,
  )
    ? false
    : true;
  refined.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESS = raw.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESS;
  refined.TRANSMITTER_REDUNDANCY_SWITCH_TAGS = raw.TRANSMITTER_REDUNDANCY_SWITCH_TAGS;
  refined.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES = raw.TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES;

  /*** * Save to ConfiguratorData.Result * ***/

  ConfiguratorData.Result = refined;

  /*** * Return ConfiguratorData.Result * ***/

  console.log("Configurator : ", ConfiguratorData.Result);

  return ConfiguratorData.Result;
}
